<template>
    <Navigation :title="$t('payment.title')"/>
    <div class="pb-5 bg-finger">
        <div class="container" style="height: 120px">

        </div>
        <div class="container-fluid position-absolute payment-card">
            <div class="card py-4">
                <div class="card-body">
                    <h4 class="text-center">{{ $t('payment.amountToPay') }}</h4>
                    <p class="fw-bold fs-4 text-center">
                        {{'Rp.'+Intl.NumberFormat('en-US').format(checkoutData.price_sum)}}</p>
                    <div class="d-block text-center mb-3 fw-bold">{{ $t('payment.bankInfo') }}</div>
                    <p class="text-center fw-bold">{{ $t('payment.uploadProof') }}</p>
                    <button class="btn btn-outline-primary d-block mx-auto" data-bs-toggle="modal"
                            data-bs-target="#exampleModal"><i class="bi bi-upload"></i> {{ $t('payment.uploadButton') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid mb-5 pb-3 payment-info">
        <div class="fs-3 text-center mb-3 fw-bold">
            <i class="bi bi-info-circle"></i> {{ $t('payment.importantInfo') }}
        </div>
        <ol>
            <li class="mb-2" v-for="(instruction, index) in $t('payment.paymentInstructions')" :key="index">
              {{ instruction }}
            </li>
        </ol>
    </div>
    <BottomNav/>

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{ $t('payment.uploadModalTitle') }}</h5>
                </div>
                <div class="modal-body">
                    <input type="file" ref="file" class="form-control" @change="select_img">
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('payment.cancel') }}</button>
                    <button type="button" class="btn btn-primary" @click="upload" data-bs-dismiss="modal">{{ $t('payment.upload') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Navigation from "../components/Navigation";
    import BottomNav from "../components/BottomNav";
    import axios from 'axios'
    import Swal from "sweetalert2";

    export default {
        name: "Payment",
        components: {BottomNav, Navigation},
        data() {
            return {
                checkoutData: [],
                transfer_img: undefined
            }
        },
        mounted() {
            this.checkoutData = this.$store.getters.getCheckout
            document.body.style.backgroundColor = '#EEEFFF'
        },
        unmounted() {
            this.$store.dispatch('setCheckout', {})
            document.body.style.backgroundColor = '#FFFFFF'
        },
        methods: {
            select_img() {
                this.transfer_img = this.$refs.file.files
            },
            async upload() {
                try {
                    const formData = new FormData();
                    formData.append('id', this.checkoutData.payment_id)
                    formData.append('transfer_img', this.transfer_img.item(0))

                    await axios.post('/api/upload_invoice', formData, {headers: {'Content-Type': 'multipart/form-data'}})
                    this.$router.push('/transactions')
                } catch (error) {
                    Swal.fire('Error', this.$t('checkoutFailed'), 'error')
                    console.error('Upload error:', error)
                }
            }
        }
    }
</script>

<style scoped>
.payment-card {
    top: 120px;
}

.payment-info {
    padding-top: 15em;
}
</style>

<style scoped>
    .bg-finger {
        background: #08A0F1 url("/img/fpimageup.png");
        background-size: cover;
    }
</style>
